import { cn } from '@/utils/cn'
import * as LabelPrimitive from '@radix-ui/react-label'
import { forwardRef } from 'react'

export const Label = forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      'font-medium text-white/70 leading-none transition-all focus-within:text-turquoise peer-focus-visible:text-turquoise peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className
    )}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName
